//@ts-nocheck
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus, faCheck } from "@fortawesome/free-solid-svg-icons";
import { AnimatePresence, motion } from "framer-motion";
import { useState } from "react";
import { useCartContext } from "app/providers/CartProvider";
import { CategoryStandardProduct } from "shared/api/middleware-api-client";

interface ProductProps {
  product: CategoryStandardProduct;
}
export const QuantitySelector: React.FC<ProductProps> = ({ product }) => {
  const [quantity, setQuantity] = useState(1);
  const [toCartClicked, setToCartClicked] = useState(false);

  const { addCartStandardProduct } = useCartContext();

  const addStandardProductToCart = () => {
    addCartStandardProduct({ ...product, amount: quantity });
    setToCartClicked(true);
  };
  return (
    <section className=" gg-flex gg-gap-x-2.5  gg-font-black gg-whitespace-nowrap gg-flex-row gg-pr-2">
      <div className=" gg-flex gg-gap-4 gg-items-center  gg-px-3 sm:gg-py-1.5 gg-text-xs gg-bg-white gg-rounded-sm gg-border gg-border-solid gg-border-zinc-300 gg-text-[#9493A3]">
        <div
          role="button"
          tabIndex={1}
          className="hover:gg-scale-110 hover:gg-text-black gg-cursor-pointer gg-border-none gg-text-center"
          aria-label="Decrease quantity"
          onClick={() => setQuantity((prev) => Math.max(prev - 1, 1))}
        >
          <FontAwesomeIcon icon={faMinus} size="sm" />
        </div>
        <div className="gg-w-2 gg-text-center  gg-text-sm gg-font-light gg-text-gray-500">
          {quantity}
        </div>
        <div
          role="button"
          tabIndex={2}
          className="hover:gg-scale-110 hover:gg-text-black gg-cursor-pointer gg-border-none  gg-text-center"
          aria-label="Increase quantity"
          onClick={() => setQuantity((prev) => prev + 1)}
        >
          <FontAwesomeIcon icon={faPlus} size="sm" />
        </div>
      </div>
      <AnimatePresence>
        <motion.button
          className="gg-cursor-pointer  gg-border-none  gg-justify-center gg-items-center gg-px-2.5 sm:gg-px-3 gg-w-8 gg-h-8 sm:gg-w-9 sm:gg-h-9 gg-text-xs gg-text-center gg-bg-yellow-300 gg-rounded-sm gg-text-dark-blue"
          aria-label="Add to cart"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.9 }}
          onClick={addStandardProductToCart}
        >
          {!toCartClicked && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1, transition: { duration: 1 } }}
              exit={{ opacity: 0, transition: { duration: 1 } }}
            >
              <FontAwesomeIcon icon={faPlus} size="lg" />
            </motion.div>
          )}
          {toCartClicked && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1, transition: { duration: 1 } }}
              exit={{ opacity: 0, transition: { duration: 1 } }}
            >
              <FontAwesomeIcon icon={faCheck} size="lg" />
            </motion.div>
          )}
        </motion.button>
      </AnimatePresence>
    </section>
  );
};
